export const PRODUCT_PRICING_GET_REQUEST = 'PRODUCT_PRICING_GET_REQUEST';
export const PRODUCT_PRICING_GET_SUCCESS = 'PRODUCT_PRICING_GET_SUCCESS';
export const PRODUCT_PRICING_GET_ERROR = 'PRODUCT_PRICING_GET_ERROR';
export const PRODUCT_PRICING_FALLBACK_GET_REQUEST = 'PRODUCT_PRICING_FALLBACK_GET_REQUEST';
export const PRODUCT_PRICING_FALLBACK_GET_SUCCESS = 'PRODUCT_PRICING_FALLBACK_GET_SUCCESS';
export const PRODUCT_PRICING_FALLBACK_GET_ERROR = 'PRODUCT_PRICING_FALLBACK_GET_ERROR';
export const SET_BUNDLE_PRODUCT_PRICING = 'SET_BUNDLE_PRODUCT_PRICING';
